import React from 'react'
import CIcon from 'compat/coreui-icon'

const _nav = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon name="cil-speedometer" customClasses="c-sidebar-nav-icon" />,
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'View Public Profile',
    to: '/dashboard/publicProfile',
    icon: 'cil-list',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Upgrade',
    to: '/dashboard/upgrade',
    icon: 'cil-list',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Invoices',
    to: '/dashboard/invoice',
    icon: 'cil-list',
  },

  {
    _tag: 'CSidebarNavItem',
    name: 'Category',
    to: '/dashboard/category',
    icon: 'cil-list'
  },
  //  {
  //   _tag: 'CSidebarNavItem',
  //   name: 'Menu & Products',
  //   to: '/dashboard/products',
  //   icon: 'cil-cursor'
  // },
  {
    _tag: 'CSidebarNavItem',
    name: 'Menu & Products',
    to: '/dashboard/menu-products',
    icon: 'cil-cursor'
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Orders',
    to: '/dashboard/orders',
    icon: 'cil-cursor'
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Deals',
    to: '/dashboard/deals',
    icon: 'cil-chart-pie'
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Edit Profile',
    to: '/dashboard/edit',
    icon: 'cil-puzzle'
  },
  {
      _tag: 'CSidebarNavItem',
      name: 'Pre-Order',
      to: '/dashboard/pre-order',
      icon: 'cil-chart-pie'
    },

  {
    _tag: 'CSidebarNavItem',
    name: 'Reviews',
    to: '/dashboard/reviews',
    icon: 'cil-chart-pie'
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Photos',
    to: '/dashboard/gallery',
    icon: 'cil-star'
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Widgets',
    to: '#',
    icon: 'cil-chart-pie'
  },
  {
    _tag: 'CSidebarNavDropdown',
    name: 'Analytics & Insights',
    route: '/dashboard/analytics',
    icon: 'cil-puzzle',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'Followers',
        to: '/dashboard/analytics/followers',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Visitors',
        to: '/dashboard/analytics/visitors',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Pre-Order',
        to: '/dashboard/analytics/pre-order',
      },
    ],
  },
  /*{
    _tag: 'CSidebarNavDropdown',
    name: 'Buttons',
    route: '/buttons',
    icon: 'cil-cursor',
    _children: [
      {
        _tag: 'CSidebarNavItem',
        name: 'Buttons',
        to: '/buttons/buttons',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Brand buttons',
        to: '/buttons/brand-buttons',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Buttons groups',
        to: '/buttons/button-groups',
      },
      {
        _tag: 'CSidebarNavItem',
        name: 'Dropdowns',
        to: '/buttons/button-dropdowns',
      }
    ],
  },*/
  {
    _tag: 'CSidebarNavItem',
    name: 'Contact US',
    to: '/contact',
    icon: 'cil-chart-pie'
  },
]

export default _nav
